/**
 * Where an order is in its life.  The same values as the OrderStatus of the API: whether it is being worked on, and
 * how far the production, the shipment and the invoice have got are statuses of their own.
 */
export enum OrderStatus {
    Cancelled = -1,
    Pending = 0,
    Open = 1,
    Active = 2,
    Completed = 3
}

export const OrderStatusMetadata = {
    '-1': {
        display: 'Cancelled',
        class: 'cancelled',
        value: -1
    },
    '0': {
        display: 'Pending',
        class: 'pending',
        value: 0
    },
    '1': {
        display: 'Open',
        class: 'open',
        value: 1
    },
    '2': {
        display: 'Active',
        class: 'active',
        value: 2
    },
    '3': {
        display: 'Completed',
        class: 'completed',
        value: 3
    }
};
